// src/components/PhotoCarousel.jsx
import React from 'react';
// Importamos los componentes de Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
// Importamos los módulos necesarios (Autoplay)
import { Autoplay, Pagination } from 'swiper/modules';

// Importamos los estilos de Swiper
import 'swiper/css';
import 'swiper/css/pagination';

export default function PhotoCarousel({ images }) {
  if (!images || images.length === 0) return null;

  return (
    <div className="py-10 bg-gray-100">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl font-bold mb-6 text-center">Nuestra Galería</h2>
        
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={20} // Espacio entre fotos
          slidesPerView={1} // Por defecto 1 en móvil
          loop={true} // Infinito
          autoplay={{
            delay: 3000, // Cambia cada 3 segundos
            disableOnInteraction: false, // Sigue pasando aunque el usuario lo toque
          }}
          pagination={{ clickable: true }}
          breakpoints={{
            // Configuración responsive
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="pb-12" // Espacio para los puntitos de paginación
        >
          {images.map((img, index) => (
            <SwiperSlide key={index}>
              <div className="h-60">
                <img 
                  src={img.signedUrl || img.url}
                  alt={img.alt || 'Carousel item'}
                  className="w-full h-full object-cover rounded-xl shadow-md"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}